module.exports = __webpack_public_path__ + "static/media/05.a4d058cf.png";